<template>
  <div class="head" :class="{ 'lang-th': lang == 'th', 'lang-vi': lang == 'vi' }">
    <topTips v-if="topT == 1 && token" />
    <header class="topbar-header">
      <div class="topbar-container">
        <a class="logo-wrap" :href="host + lang + '/home'" aria-label="FISG Home" data-home-link>
          <div class="logo-box">
            <img src="https://isgvideo.s3.ap-southeast-1.amazonaws.com/public/uploads/2026/09/logo-15th-iniesta-2.webp"
              alt="FISG Logo" />
          </div>
        </a>

        <div class="navbar-collapse" id="navRoot">
          <nav class="navbar-nav" aria-label="Main navigation">
            <ul class="navbar-nav-list" id="mainNavList">
              <li v-for="section in navSections" :key="section.key" class="navbar-nav-item has-dropdown"
                :class="{ 'is-open': activeDropdown === section.key }" @mouseenter="computeDxOnly(section.key, $event)">
                <a class="navbar-link" href="#" @click.prevent="toggleDropdown(section.key, $event)">
                  {{ section.label }}
                </a>
                <div class="navbar-nav-dropdown-menu"
                  :class="{ 'mega-menu': section.key === 'trading', 'campaign-menu': section.key === 'campaigns' }"
                  :style="{ '--dx': dropdownDx[section.key] || '0px' }">
                  <template v-if="section.key === 'trading'">
                    <ul class="navbar-nav-dropdown-menu-list" v-for="(column, colIndex) in buildColumns(section.items)"
                      :key="colIndex">
                      <template v-for="(item, itemIdx) in column">
                        <li v-if="item.type === 'title'" :key="'title-' + itemIdx"
                          class="navbar-nav-dropdown-menu-item-title">{{ item.label }}</li>
                        <li v-else :key="'link-' + itemIdx">
                          <a class="navbar-link" v-if="item.isInternal" :href="host + lang + '/' + item.slug"
                            target="_self">{{ item.label }}</a><a class="navbar-link" v-else :href="item.path"
                            :target="isExternal(item.path) ? '_blank' : '_self'">{{ item.label }}</a>
                        </li>
                      </template>
                    </ul>
                  </template>
                  <template v-else>
                    <ul class="navbar-nav-dropdown-menu-list">
                      <template v-for="(item, itemIdx) in section.items">
                        <li v-if="item.type === 'title'" :key="'title-' + itemIdx"
                          class="navbar-nav-dropdown-menu-item-title">{{ item.label }}</li>
                        <li v-else :key="'link-' + itemIdx">
                          <a class="navbar-link" v-if="item.isInternal" :href="host + lang + '/' + item.slug"
                            target="_self">{{ item.label }}</a><a class="navbar-link" v-else :href="item.path"
                            :target="isExternal(item.path) ? '_blank' : '_self'">{{ item.label }}</a>
                        </li>
                      </template>
                    </ul>
                  </template>
                </div>
              </li>
            </ul>
          </nav>
        </div>

        <div class="desktop-actions" id="desktopActions">
          <a class="navbar-point-mall" href="https://mall.fisg.com/" target="_blank" rel="noopener noreferrer">
            <span class="navbar-point-mall-default" aria-hidden="true">
              <span class="navbar-point-mall-icon-border"><span class="navbar-point-mall-icon"></span></span>
            </span>
            <span class="navbar-point-mall-hover" aria-hidden="true">
              <img src="https://www.fisg.com/images/Point%20mall%20icon.png" alt="" width="24" height="24" />
            </span>
            <span class="navbar-point-mall-text">Point Mall</span>
          </a>

          <a class="navbar-start" :href="registerLink" target="_blank" rel="noopener noreferrer">
            <span class="navbar-start-inner">{{ $t('other.ctaTradeNow') }}</span>
          </a>

          <a v-if="!anniu_login" class="login-btn" @click.prevent="pageTo(6)" href="#" rel="noopener noreferrer">{{
            $t('other.login') }}</a>
          <a v-else class="login-btn" @click.prevent="enter('/meber')" href="#" rel="noopener noreferrer">{{
            $t('myhead.Personalcenter') }}</a>

          <nav class="navbar-nav" aria-label="Language selector">
            <ul class="navbar-nav-list">
              <li class="navbar-nav-item has-dropdown" :class="{ 'is-open': activeDropdown === 'lang' }"
                @mouseenter="computeDxOnly('lang', $event)">
                <a class="navbar-link lang-trigger" href="#" aria-label="Change language"
                  @click.prevent="toggleDropdown('lang', $event)">
                  <svg class="lang-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"
                    stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <circle cx="12" cy="12" r="9"></circle>
                    <path d="M3 12h18"></path>
                    <path d="M12 3a15 15 0 0 1 0 18"></path>
                    <path d="M12 3a15 15 0 0 0 0 18"></path>
                  </svg>
                </a>
                <div class="navbar-nav-dropdown-menu align-right" :style="{ '--dx': dropdownDx['lang'] || '0px' }">
                  <ul class="navbar-nav-dropdown-menu-list">
                    <li v-for="(l, index) in languages" :key="l.code + index">
                      <a class="navbar-link" :class="{ active: l.code === lang }" href="#"
                        @click.prevent="langFn(l.code)">
                        <img class="flag-icon" :src="flagEmojiToTwemojiUrl(l.emoji)" alt="" loading="lazy" />
                        <span>{{ l.nativeName }}</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </nav>
        </div>

        <button class="mobile-toggle" :class="{ 'is-active': mobileNavOpen }" @click="toggleMobileNav" type="button"
          aria-label="Open menu">
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </button>
      </div>

      <nav class="mobile-nav-overlay" :class="{ 'is-open': mobileNavOpen }" id="mobileNav"
        aria-label="Mobile navigation">
        <ul class="mobile-accordion">
          <li v-for="section in navSections" :key="section.key" class="mobile-accordion-item"
            :class="{ 'is-open': mobileAccordionOpen === section.key }">
            <button class="mobile-accordion-header" type="button" @click="toggleMobileAccordion(section.key)">
              <span>{{ section.label }}</span>
              <svg class="mobile-chevron" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <polyline points="6 9 12 15 18 9"></polyline>
              </svg>
            </button>
            <div class="mobile-panel">
              <template v-for="(item, itemIdx) in section.items">
                <div v-if="item.type === 'title'" :key="'m-title-' + itemIdx" class="mobile-section-title">{{ item.label
                  }}</div>
                <a v-else-if="item.isInternal" :key="'m-link-' + itemIdx" class="mobile-link"
                  :href="host + lang + '/' + item.slug" target="_self" @click="mobileNavOpen = false">{{ item.label
                  }}</a>
                <a v-else :key="'m-ext-link-' + itemIdx" class="mobile-link" :href="item.path"
                  :target="isExternal(item.path) ? '_blank' : '_self'" @click="mobileNavOpen = false">{{ item.label
                  }}</a>
              </template>
            </div>
          </li>
        </ul>
        <div class="mobile-actions">
          <a class="navbar-start" :href="registerLink" target="_blank" rel="noopener noreferrer">
            <span class="navbar-start-inner">{{ $t('other.ctaTradeNow') }}</span>
          </a>
          <div class="mobile-actions-row">
            <a v-if="!anniu_login" class="login-btn" @click.prevent="pageTo(6)" href="#" rel="noopener noreferrer">{{
              $t('other.login') }}</a>
            <a v-else class="login-btn" @click.prevent="enter('/meber')" href="#" rel="noopener noreferrer">{{
              $t('myhead.Personalcenter') }}</a>
            <span class="mobile-divider" aria-hidden="true"></span>
            <a href="https://mall.fisg.com/" target="_blank" rel="noopener noreferrer" aria-label="Point Mall">
              <img src="https://www.fisg.com/images/Point%20mall%20icon.png" alt="" width="24" height="24" />
            </a>
          </div>
          <div class="mobile-actions-row">
            <button class="navbar-link" :class="{ 'active': mobileLangOpen }" @click="mobileLangOpen = !mobileLangOpen"
              type="button" aria-label="Change language">
              <svg class="lang-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"
                stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <circle cx="12" cy="12" r="9"></circle>
                <path d="M3 12h18"></path>
                <path d="M12 3a15 15 0 0 1 0 18"></path>
                <path d="M12 3a15 15 0 0 0 0 18"></path>
              </svg>
            </button>
          </div>
          <div class="mobile-panel mobile-lang-grid" :class="{ 'is-open': mobileLangOpen }">
            <button v-for="(l, index) in languages" :key="l.code + index" class="mobile-link"
              :class="{ active: l.code === lang }" @click="langFn(l.code)" type="button">
              <img class="flag-icon" :src="flagEmojiToTwemojiUrl(l.emoji)" alt="" loading="lazy" />
              <span>{{ l.nativeName }}</span>
            </button>
          </div>
        </div>
      </nav>
    </header>
    <!-- topbar-header 是 fixed 定位不占文档流，用占位条顶出同样高度，避免后面内容被遮住 -->
    <div class="topbar-spacer" aria-hidden="true"></div>
  </div>
</template>

<script>
import { changeLang } from '@/utils/util.js'
import topTips from './topTips.vue'

const BASE_URL = "https://www.fisg.com";
const HIDDEN_LANDING_PATHS = new Set(["world-cup-prediction-contest"]);

const campaignConfig = [
  { name: "Celebrate FISG 14 Years", path: "celebrate-fisg-14-years", languages: ["lo"], vpn: ["lo"], type: "labelPromotion" },
  { name: "Deposit and Trade to Win", path: "deposit-and-trade-to-win", languages: [], vpn: [], type: "labelPromotion" },
  { name: "Deposit bonus", path: "deposit-bonus", languages: [], vpn: [], type: "labelPromotion" },
  { name: "สัมมนาออฟไลน์", path: "seminar", languages: ["th"], vpn: ["th"], type: "labelPromotion", education: true },
  // hidden: campaign closed
  // {
  //   name: {
  //     en: "New Comer Bonus",
  //     lo: "New Comer Bonus",
  //     ms: "New Comer Bonus",
  //     th: "New Comer Bonus",
  //     vi: "New Comer Bonus",
  //     za: "New Comer Bonus"
  //   },
  //   path: "new-comer-bonus",
  //   languages: ["en", "lo", "ms", "th", "vi", "za"],
  //   vpn: ["en", "lo", "ms", "th", "vi", "za"],
  //   type: "labelPromotion"
  // },
  {
    name: {
      en: "FISG Breakout Lucky Draw",
      th: "FISG Breakout Lucky Draw"
    },
    path: "breakout-lucky-draw",
    languages: ["th"],
    vpn: ["th"],
    type: "labelPromotion"
  },
  { name: "FISG Membership", path: "fisg-membership", languages: ["en", "lo", "ms", "th", "vi", "zh-tw"], vpn: ["all"], type: "labelContest" },
  { name: "FISG Seminar SA", path: "fisg-seminar-sa", languages: ["za"], vpn: ["za"], type: "labelPromotion" },
  {
    name: {
      en: "FISG Non-Farm Payrolls Forecast Challenge",
      lo: "ຄາດການຕົວເລກການຈ້າງງານ FISG",
      ms: "Cabaran Ramalan Penggajian Bukan Ladang FISG",
      th: "ทายผล Non-Farm Payrolls กับ FISG",
      vi: "Thử Thách Dự Đoán Bảng Lương Phi Nông Nghiệp FISG"
    },
    path: "non-farm-payrolls-forecast-challenge",
    languages: ["en", "lo", "ms", "th", "vi", "zh-tw"],
    vpn: ["all"],
    type: "labelPromotion"
  },
  {
    name: {
      en: "FISG Webinar",
      lo: "ສົດໆກັບ FISG Webinar",
      ms: "FISG Webinar",
      th: "สัมมนาออนไลน์",
      vi: "Trực Tuyến with Webinar FISG",
      "zh-tw": "FISG Webinar"
    },
    path: "live-trading-webinar",
    languages: ["en", "lo", "ms", "th", "vi", "zh-tw"],
    vpn: ["en", "es", "id", "ja", "ko", "lo", "ms", "ru", "th", "vi"],
    type: "labelPromotion",
    education: true
  },
  { name: { th: "Top Lot Trading Competition", lo: "ການເເຂ່ງເທຣດ Top Lot" }, path: "top-lot-trading-competition", languages: ["th", "lo"], vpn: ["th", "lo"], type: "labelContest" },
  { name: "Sweepstakes", path: "sweepstakes", languages: [], vpn: [], type: "labelPromotion" },
  { name: "Trade for Prize 2026", path: "trade-for-prize-2026", languages: ["th"], vpn: ["th"], type: "labelPromotion" }
];

const navTemplate = [
  {
    key: "about",
    labelKey: "other.sections.about",
    items: [
      ["title", "other.about.title"],
      ["link", "other.about.aboutFISG", "about-us"],
      ["link", "other.about.legalCompliance", "legal-compliance"],
      ["link", "other.about.clientReviews", "client-review"],
      ["link", "other.about.insurance", "insurance"],
      ["link", "other.about.events", "interstellar-events"],
      ["link", "other.about.partnership", "partnership"]
    ]
  },
  {
    key: "trading",
    labelKey: "other.sections.trading",
    items: [
      ["title", "other.trading.platformTitle"],
      ["link", "other.trading.mt4", "mt4"],
      ["link", "other.trading.mt5", "mt5"],
      ["link", "other.trading.webTerminal", "metatraders-webterminal"],
      ["link", "other.trading.copyTrade", "copy-trade"],
      ["link", "other.trading.app", "fisg-app"],
      ["title", "other.trading.marketsTitle"],
      ["link", "other.trading.forex", "forex-trade"],
      ["link", "other.trading.metals", "metals-trade"],
      ["link", "other.trading.energy", "energy-trade"],
      ["link", "other.trading.index", "indices-trade"],
      ["link", "other.trading.stock", "stocks"],
      ["link", "other.trading.cryptocurrency", "cryptocurrency-trading"],
      ["title", "other.trading.accountTitle"],
      ["link", "other.trading.accountTypes", "account-type"],
      ["link", "other.trading.leverage", "leverage-policy"],
      ["link", "other.trading.depositWithdrawal", "deposit-withdrawal"],
      ["title", "other.trading.toolsTitle"],
      ["link", "other.trading.mam", "mam"],
      ["link", "other.trading.pamm", "pamm"],
      ["link", "other.trading.multiTerminal", "multiterminal"],
      ["link", "other.trading.calculator", "calculator"]
    ]
  },
  { key: "campaigns", labelKey: "other.sections.campaigns", items: [["title", "other.campaigns.title"]] },
  {
    key: "education",
    labelKey: "other.sections.education",
    items: [
      ["title", "other.education.title"],
      ["campaign", "seminar"],
      ["campaign", "live-trading-webinar"],
      ["link", "other.education.whatIsForex", "what-is-forex-trading-how-does-it-work"],
      ["link", "other.education.course", "trading-course"],
      ["link", "other.education.investment", "educational-articles"],
      ["link", "other.education.glossary", "assembly"],
      ["link", "other.education.faq", "faq"]
    ]
  },
  {
    key: "markets",
    labelKey: "other.sections.markets",
    items: [
      ["title", "other.markets.title"],
      ["link", "other.markets.notices", "fisg-notices"],
      ["link", "other.markets.analysis", "fisg-analysis"],
      ["link", "other.markets.calendar", "economic-calendar"],
      ["link", "other.markets.transaction", "transaction-analysis"],
      ["link", "other.markets.news", "real-time-news"],
      ["link", "other.markets.times", "fisg-times"],
      ["link", "other.markets.marketWrap", "market-wrap"]
    ]
  }
];

export default {
  name: "MyHead",
  components: {
    topTips,
  },
  data() {
    return {
      token: '',
      host: 'https://www.fisg.com/',
      anniu_login: false,
      lang: localStorage.getItem('lang') || 'en',
      
      activeDropdown: null,
      dropdownDx: {},
      mobileNavOpen: false,
      mobileAccordionOpen: null,
      mobileLangOpen: false,

      languages: [
        { code: "en", emoji: "🇬🇧", nativeName: "English" },
        { code: "id", emoji: "🇮🇩", nativeName: "Bahasa Indonesia" },
        { code: "ja", emoji: "🇯🇵", nativeName: "日本語" },
        { code: "ko", emoji: "🇰🇷", nativeName: "한국어" },
        { code: "ms", emoji: "🇲🇾", nativeName: "Bahasa Melayu" },
        { code: "th", emoji: "🇹🇭", nativeName: "ภาษาไทย" },
        { code: "ru", emoji: "🇷🇺", nativeName: "Русский" },
        { code: "vi", emoji: "🇻🇳", nativeName: "Tiếng Việt" },
        { code: "lo", emoji: "🇱🇦", nativeName: "ພາສາລາວ" },
        { code: "es", emoji: "🇪🇸", nativeName: "Español" },
        { code: "en", emoji: "🇿🇦", nativeName: "South Africa" }
        // { code: "es", emoji: "🇪🇸", nativeName: "Español" },
        // { code: "za", emoji: "🇿🇦", nativeName: "South Africa" }
      ]
    }
  },
  computed: {
    topT() {
      return localStorage.getItem('topTips') || '0'
    },
    registerLink() {
      return `https://my.fisg.com/register?lang=${this.lang}&link_id=${this.lang}`
    },
    navSections() {
      return navTemplate.map((section) => {
        const items = [];
        section.items.forEach((item) => {
          if (item[0] === "title") {
            items.push({ type: "title", label: this.$t(item[1]) });
            return;
          }
          if (item[0] === "campaign") {
            const resolved = this.campaignItem(item[1]);
            if (resolved) items.push(resolved);
            return;
          }
          items.push({ type: "link", label: this.$t(item[1]), slug: item[2], isInternal: true });
        });

        if (section.key === "campaigns") {
          items.push(...this.getCampaignItems());
        }

        return { key: section.key, label: this.$t(section.labelKey), items };
      });
    }
  },
  created() {
    this.token = localStorage.getItem('token')
  },
  mounted() {
    document.addEventListener('click', this.handleOutsideClick);
    this.login_init()
    if (this.lang === 'zh' || this.lang === 'zh-tw') {
      this.host = 'https://www.fisg.com/'
    } else {
      this.host = 'https://www.fisg.com/'
    }
  },

  beforeDestroy() {
    document.removeEventListener('click', this.handleOutsideClick);
  },
  methods: {
    handleOutsideClick(event) {
      const navRoot = document.getElementById('navRoot');
      const desktopActions = document.getElementById('desktopActions');
      const mobileNav = document.getElementById('mobileNav');
      const mobileToggle = document.querySelector('.mobile-toggle');

      const target = event.target;
      const clickedDesktop = target && ((navRoot && navRoot.contains(target)) || (desktopActions && desktopActions.contains(target)));
      const clickedMobile = target && ((mobileNav && mobileNav.contains(target)) || (mobileToggle && mobileToggle.contains(target)));

      if (!clickedDesktop) {
        this.closeDropdown();
      }
      if (!clickedMobile && window.innerWidth < 1280) {
        this.mobileNavOpen = false;
        this.mobileLangOpen = false;
      }
    },
    flagEmojiToTwemojiUrl(emoji) {
      return "https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/" +
        Array.from(emoji).map((char) => char.codePointAt(0).toString(16)).join("-") +
        ".svg";
    },
    localPath(slug) {
      return this.host + this.lang + "/" + slug;
    },
    isExternal(url) {
      return /^https?:\/\//.test(url) && !url.startsWith(this.host);
    },
    langFn(name) {
      let token = localStorage.getItem('token')
      changeLang(name, this)
      this.lang = name;
      this.closeDropdown();
      this.mobileLangOpen = false;
      this.mobileNavOpen = false;
      if (token) {
        location.reload()
      }
    },
    pageTo(key) {
      if (key === 6) {
        const lang = this.lang;
        const href = `${lang == 'vi' ? 'https://my.fisg-vn.com/login' : 'https://my.fisg.com/login'}?lang=${lang}&redirect_mall=${encodeURIComponent(location.origin)}`
        window.open(href, '_self')
      } else {
        this.$router.push('/')
      }
    },
    enter(name) {
      this.$router.push(name)
    },
    login_init() {
      if (localStorage.getItem('token')) {
        this.anniu_login = true
      } else {
        this.anniu_login = false
      }
    },
    
    computeDxOnly(key, event) {
      this.$nextTick(() => {
        const target = event.currentTarget;
        const menu = target.querySelector('.navbar-nav-dropdown-menu');
        if (menu) this.computeDx(menu, key);
      });
    },
    openDropdown(key, event) {
      this.activeDropdown = key;
      this.$nextTick(() => {
        const target = event.currentTarget.closest('.has-dropdown');
        if (!target) return;
        const menu = target.querySelector('.navbar-nav-dropdown-menu');
        if (menu) this.computeDx(menu, key);
      });
    },
    toggleDropdown(key, event) {
      if (this.activeDropdown === key) {
        this.activeDropdown = null;
      } else {
        this.openDropdown(key, event);
      }
    },
    closeDropdown() {
      this.activeDropdown = null;
    },
    toggleMobileNav() {
      this.mobileNavOpen = !this.mobileNavOpen;
      if (!this.mobileNavOpen) {
        this.mobileLangOpen = false;
      }
    },
    toggleMobileAccordion(key) {
      if (this.mobileAccordionOpen === key) {
        this.mobileAccordionOpen = null;
      } else {
        this.mobileAccordionOpen = key;
      }
    },
    computeDx(menuElement, key) {
      if (!menuElement) return;
      // Temporarily clear inline variable if present to get natural bounding rect
      if (this.dropdownDx[key]) {
        this.$set(this.dropdownDx, key, "0px");
      }
      
      this.$nextTick(() => {
        const rect = menuElement.getBoundingClientRect();
        const vw = window.innerWidth;
        const margin = 12;
        let dx = 0;

        if (key === "trading") {
          const currentCenter = rect.left + rect.width / 2;
          dx = vw / 2 - currentCenter;
          const newLeft = rect.left + dx;
          const newRight = rect.right + dx;
          if (newRight > vw - margin) dx -= newRight - (vw - margin);
          if (newLeft < margin) dx += margin - newLeft;
        } else {
          if (rect.right > vw - margin) dx -= rect.right - (vw - margin);
          if (rect.left < margin) dx += margin - rect.left;
        }

        this.$set(this.dropdownDx, key, dx + "px");
      });
    },
    buildColumns(items) {
      const columns = [[], [], [], []];
      let columnIndex = 0;
      items.forEach((item) => {
        if (item.type === "title" && columns[columnIndex].length > 0) columnIndex += 1;
        if (columnIndex < columns.length) columns[columnIndex].push(item);
      });
      return columns.filter((column) => column.length > 0);
    },
    getLocalizedCampaignName(name, locale) {
      if (typeof name === "string") return name;
      const fallbacks = locale === "zh" || locale === "zh-tw" ? ["zh", "zh-tw", "en"] : [locale, locale.split("-")[0], "en"];
      for (const key of fallbacks) {
        if (name[key]) return name[key];
      }
      return Object.values(name)[0] || "";
    },
    campaignPath(entry, locale) {
      if (entry.path === "seminar") return BASE_URL + "/" + locale + "/seminar";
      const landingLocale = entry.path === "fisg-seminar-sa" ? "za" : locale;
      return BASE_URL + "/" + landingLocale + "/landing/" + entry.path;
    },
    getLocaleAliases(locale) {
      return locale === "zh" || locale === "zh-tw" ? ["zh", "zh-tw"] : [locale];
    },
    getCampaignOrder(locale) {
      const campaignOrderByLocale = {
        default: ["fisg-membership", "non-farm-payrolls-forecast-challenge"],
        en: [/* "new-comer-bonus", // hidden: campaign closed */ "fisg-membership", "non-farm-payrolls-forecast-challenge"],
        ms: [/* "new-comer-bonus", // hidden: campaign closed */ "fisg-membership", "non-farm-payrolls-forecast-challenge"],
        vi: [/* "new-comer-bonus", // hidden: campaign closed */ "fisg-membership", "non-farm-payrolls-forecast-challenge"],
        th: [/* "new-comer-bonus", // hidden: campaign closed */ "breakout-lucky-draw", "fisg-membership", "non-farm-payrolls-forecast-challenge", "trade-for-prize-2026"],
        lo: [/* "new-comer-bonus", // hidden: campaign closed */ "celebrate-fisg-14-years", "fisg-membership", "non-farm-payrolls-forecast-challenge"],
        za: [/* "new-comer-bonus", // hidden: campaign closed */ "fisg-membership", "fisg-seminar-sa", "non-farm-payrolls-forecast-challenge"]
      };
      return campaignOrderByLocale[locale] || campaignOrderByLocale.default;
    },
    campaignMatchesLocale(entry, locale, options = {}) {
      if (HIDDEN_LANDING_PATHS.has(entry.path)) return false;
      if (!options.includeEducation && entry.education) return false;
      if ((locale === "vi" || locale === "vn") && !["fisg-membership", "non-farm-payrolls-forecast-challenge"].includes(entry.path)) return false;

      const localeAliases = this.getLocaleAliases(locale);
      const vpnList = Array.isArray(entry.vpn) ? entry.vpn.map((item) => item.toLowerCase()) : [];
      const languageList = Array.isArray(entry.languages) ? entry.languages.map((item) => item.toLowerCase()) : [];
      const hasVpnRestriction = vpnList.length > 0;
      const hasLanguageRestriction = languageList.length > 0;
      const hasVpnMatch = !hasVpnRestriction || vpnList.includes("all") || vpnList.includes(locale.toLowerCase());
      const hasLanguageMatch = !hasLanguageRestriction || localeAliases.some((item) => languageList.includes(item));
      const canFallbackToEnglish = options.allowEnglishFallback && vpnList.includes("all") && languageList.includes("en");

      return hasVpnMatch && (hasLanguageMatch || canFallbackToEnglish);
    },
    resolveCampaignLocale(entry, locale, options = {}) {
      const localeAliases = this.getLocaleAliases(locale);
      const languageList = Array.isArray(entry.languages) ? entry.languages.map((item) => item.toLowerCase()) : [];
      const hasLocaleMatch = localeAliases.some((item) => languageList.includes(item));
      if (hasLocaleMatch || languageList.length === 0) return locale;
      if (options.allowEnglishFallback && languageList.includes("en")) return "en";
      return locale;
    },
    getCampaignItems() {
      return this.getCampaignOrder(this.lang)
        .map((path) => campaignConfig.find((entry) => entry.path === path))
        .filter(Boolean)
        .map((entry) => ({
          type: "link",
          label: this.getLocalizedCampaignName(entry.name, this.lang),
          path: this.campaignPath(entry, this.resolveCampaignLocale(entry, this.lang, { allowEnglishFallback: true }))
        }));
    },
    campaignItem(path) {
      const entry = campaignConfig.find((item) => item.path === path);
      if (!entry || !this.campaignMatchesLocale(entry, this.lang, { includeEducation: true, allowEnglishFallback: true })) return null;
      return {
        type: "link",
        label: this.getLocalizedCampaignName(entry.name, this.lang),
        path: this.campaignPath(entry, this.resolveCampaignLocale(entry, this.lang, { allowEnglishFallback: true }))
      };
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

.lang-th {
  font-family: 'Noto-Sans-Thai';
}

.lang-vi {
  font-family: 'NotoSansSC-VI';
}


/* @import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap"); */



* {
  box-sizing: border-box;
}

html,
.head {
  margin: 0;
  min-height: 100%;
}

.head {
  font-family: "Inter", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  color: #fff;
  background: transparent;
}

.topbar-header {
  position: fixed;
  inset: 0 0 auto;
  z-index: 40;
  pointer-events: none;
  isolation: isolate;
}

.topbar-header::before {
  content: "";
  position: absolute;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  background-color: rgba(0, 0, 0, 0.5);
  -webkit-backdrop-filter: blur(8.5px);
  backdrop-filter: blur(8.5px);
}

@media (min-width: 1280px) {
  .topbar-header::before {
    background-image:
      linear-gradient(rgba(41, 162, 126, 0.17), rgba(41, 162, 126, 0.17)),
      linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6));
  }
}

.topbar-container {
  position: relative;
  z-index: 1;
  width: min(1280px, 100%);
  height: 72px;
  margin-inline: auto;
  padding-inline: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  pointer-events: auto;
}

.topbar-spacer {
  height: 72px;
}

.logo-wrap {
  display: inline-flex;
  align-items: center;
  flex: 0 0 auto;
  text-decoration: none;
}

.logo-box {
  width: 169px;
  height: 50px;
}

.logo-box img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: contain;
}

.navbar-collapse {
  height: 100%;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.navbar-nav,
.navbar-nav-item {
  position: relative;
}

.navbar-nav-list {
  display: flex;
  align-items: center;
  gap: 18px;
  list-style: none;
  margin: 0;
  padding: 0;
}

.navbar-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: rgba(232, 242, 240, 0.95);
  text-decoration: none;
  white-space: nowrap;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  padding: 10px;
  border: 0;
  background: transparent;
  cursor: pointer;
  transition: color 0.2s ease;
}

.navbar-link:hover,
.navbar-nav-item.is-open>.navbar-link,
.navbar-link.active {
  color: #3cfcc2;
}

.navbar-nav-dropdown-menu {
  position: absolute;
  top: calc(100% + 14px);
  left: calc(var(--dx, 0px));
  z-index: 100;
  min-width: 220px;
  max-width: min(92vw, 980px);
  max-height: calc(100vh - 110px);
  overflow: auto;
  padding: 16px 24px;
  border-radius: 0 0 24px 24px;
  background-color: rgba(0, 0, 0, 0.78);
  -webkit-backdrop-filter: blur(18px);
  backdrop-filter: blur(18px);
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.48);
  opacity: 0;
  pointer-events: none;
  transform: scaleY(0.92);
  transform-origin: top center;
  transition:
    opacity 0.24s ease,
    transform 0.24s ease;
}

.navbar-nav-dropdown-menu.align-right {
  left: auto;
  right: 0;
}

.navbar-nav-item.is-open>.navbar-nav-dropdown-menu {
  opacity: 1;
  pointer-events: auto;
  transform: scaleY(1);
}

.navbar-nav-dropdown-menu-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 10px;
}

.navbar-nav-dropdown-menu.mega-menu {
  display: flex;
  align-items: flex-start;
  gap: 42px;
}

.navbar-nav-dropdown-menu.mega-menu>.navbar-nav-dropdown-menu-list {
  width: 190px;
  flex: 0 0 190px;
}

.navbar-nav-dropdown-menu.campaign-menu {
  min-width: 340px;
}

.navbar-nav-dropdown-menu-item-title {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 0 0 8px;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.5);
  color: #fff;
  font-size: 18px;
  font-weight: 400;
  white-space: nowrap;
}

.navbar-nav-dropdown-menu-item-title::before {
  content: "›";
  color: #fff;
  font-size: 40px;
  font-weight: 100;
  line-height: 0.75;
}

.navbar-nav-dropdown-menu a.navbar-link,
.navbar-nav-dropdown-menu button.navbar-link {
  width: 100%;
  justify-content: flex-start;
  padding: 0;
  color: rgba(232, 242, 240, 0.95);
  font-size: 18px;
  font-weight: 400;
}

.flag-icon {
  width: 16px;
  height: 16px;
  display: inline-block;
  border-radius: 2px;
}

.desktop-actions {
  height: 100%;
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 0 0 auto;
}

.navbar-point-mall {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #fff;
  text-decoration: none;
  white-space: nowrap;
  font-size: 16px;
  font-weight: 600;
}

.navbar-point-mall:hover .navbar-point-mall-text {
  background: linear-gradient(90deg, #fff 0%, #c1ffbe 55.29%, rgba(29, 255, 187, 0.69) 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.navbar-point-mall-default,
.navbar-point-mall-hover {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.navbar-point-mall-hover {
  display: none;
}

.navbar-point-mall:hover .navbar-point-mall-default {
  display: none;
}

.navbar-point-mall:hover .navbar-point-mall-hover {
  display: flex;
}

.navbar-point-mall-icon-border {
  width: 8px;
  height: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0.2px solid #fff;
  border-radius: 50%;
}

.navbar-point-mall-icon {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: #1dffbb;
}

.navbar-start-inner {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 40px;
  padding: 0 18px;
  border-radius: 999px;
  background-color: rgba(0, 0, 0, 0.7);
  -webkit-backdrop-filter: blur(30px);
  backdrop-filter: blur(30px);
  font-size: 16px;
  font-weight: 700;

}


.login-btn {
  color: #fff;
  text-decoration: none;
  white-space: nowrap;
  font-size: 16px;
  font-weight: 400;
  transition: color 0.2s ease;
}

.login-btn:hover {
  color: #3cfcc2;
}

.lang-trigger {
  padding-inline: 0;
}

.lang-icon {
  width: 24px;
  height: 24px;
  display: block;
}

.mobile-toggle {
  display: none;
  position: relative;
  width: 45px;
  height: 45px;
  border: 0;
  border-radius: 50%;
  background: #000;
  cursor: pointer;
}

.mobile-toggle span {
  position: absolute;
  left: 50%;
  width: 25px;
  height: 2px;
  border-radius: 2px;
  background: #00ffb3;
  transform: translateX(-50%);
  transition:
    top 0.22s ease,
    transform 0.22s ease,
    opacity 0.18s ease;
}

.mobile-toggle span:nth-child(1) {
  top: calc(50% - 10px);
}

.mobile-toggle span:nth-child(2) {
  top: 50%;
}

.mobile-toggle span:nth-child(3) {
  top: calc(50% + 10px);
}

.mobile-toggle.is-active span:nth-child(1) {
  top: 50%;
  transform: translateX(-50%) rotate(45deg);
}

.mobile-toggle.is-active span:nth-child(2) {
  opacity: 0;
}

.mobile-toggle.is-active span:nth-child(3) {
  top: 50%;
  transform: translateX(-50%) rotate(-45deg);
}

.mobile-nav-overlay {
  display: none;
}

@media (max-width: 1279px) {
  .topbar-container {
    width: 100%;
  }

  .navbar-collapse,
  .desktop-actions {
    display: none;
  }

  .mobile-toggle {
    display: inline-flex;
    flex: 0 0 auto;
  }

  .mobile-nav-overlay.is-open {
    position: fixed;
    top: 72px;
    left: 12px;
    right: 12px;
    z-index: 60;
    display: block;
    max-height: calc(100vh - 92px);
    overflow-y: auto;
    padding: 16px 0 12px;
    border-radius: 0 0 24px 24px;
    background: rgba(0, 0, 0, 0.72);
    -webkit-backdrop-filter: blur(8.5px);
    backdrop-filter: blur(8.5px);
    pointer-events: auto;
  }

  .mobile-accordion {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .mobile-accordion-item+.mobile-accordion-item {
    border-top: 1px solid rgba(255, 255, 255, 0.7);
  }

  .mobile-accordion-header {
    width: 100%;
    min-height: 48px;
    padding: 12px 14px;
    border: 0;
    background: transparent;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    font-size: 17px;
    font-weight: 400;
    text-align: left;
  }

  .mobile-accordion-header:hover {
    color: #3cfcc2;
  }

  .mobile-chevron {
    transition: transform 0.2s ease;
  }

  .mobile-accordion-item.is-open .mobile-chevron {
    transform: rotate(180deg);
  }

  .mobile-panel {
    display: none;
    padding: 0 24px 12px;
  }

  .mobile-accordion-item.is-open .mobile-panel {
    display: grid;
    gap: 8px;
  }

  .mobile-section-title {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 8px 0 4px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.75);
    color: #fff;
    font-size: 17px;
    font-weight: 400;
  }

  .mobile-section-title::before {
    content: "›";
    font-size: 34px;
    font-weight: 100;
    line-height: 1;
  }

  .mobile-link {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    min-height: 28px;
    padding: 0;
    border: 0;
    background: transparent;
    color: #fff;
    cursor: pointer;
    text-decoration: none;
    font-size: 16px;
    line-height: 1.35;
    text-align: left;
  }

  .mobile-link:hover,
  .mobile-link.active {
    color: #3cfcc2;
  }

  .mobile-actions {
    display: grid;
    gap: 16px;
    padding: 18px 0 4px;
  }

  .mobile-actions .navbar-start {
    width: calc(100% - 4rem);
    margin-inline: 2rem;
  }

  .mobile-actions-row {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
  }

  .mobile-divider {
    width: 1px;
    height: 24px;
    background: #fff;
  }

  .mobile-lang-grid {
    display: none;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px 16px;
  }

  .mobile-lang-grid.is-open {
    display: grid;
  }
}

@media (max-width: 767px) {
  .topbar-container {
    height: 54px;
    padding-inline: 10px;
  }

  .topbar-spacer {
    height: 54px;
  }

  .logo-box {
    width: 132px;
    height: 39px;
  }

  .mobile-toggle {
    width: 42px;
    height: 42px;
  }

  .mobile-nav-overlay.is-open {
    top: 54px;
    left: 0;
    right: 0;
    max-height: calc(100vh - 54px);
    border-radius: 0 0 20px 20px;
  }

  .mobile-lang-grid {
    grid-template-columns: 1fr;
  }
}
</style>

<style>
.navbar-start {
  position: relative;
  display: inline-flex;
  flex-direction: column;
  padding: 2px;
  border-radius: 999px;
  color: #fff;
  text-decoration: none;
  overflow: hidden;
  z-index: 1;
}

.navbar-start::before {
  content: "";
  position: absolute;
  top: -100%;
  left: -100%;
  width: 300%;
  height: 300%;
  background: conic-gradient(from 0deg, #000 0% 50%, #00ffb3, #268aff, #52eaea, #262d37);
  animation: btnAnimationFallback 2.8s linear infinite;
  z-index: -1;
}

.navbar-start:hover::before {
  animation-play-state: paused;
}

.navbar-start:hover {
  color: #00ffb3;
}

@keyframes btnAnimationFallback {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
